<template>
    <v-app-bar :extension-height="40">
        <template v-if="$vuetify.theme.dark" v-slot:img="{ props }">
            <v-img
                v-bind="props"
                gradient="to top right, rgba(42,42,82,.5), rgba(100,115,201,.9)"
            ></v-img>
        </template>
        <template v-slot:extension>
            <tabs />
        </template>
        <logo />
        <v-spacer />
        <search />
        <v-spacer />
        <settings-menu />
        <refresh />
        <logout />
    </v-app-bar>
</template>

<script>
import Logo from "./LogoComponent";
import Search from "./SearchComponent";
import Tabs from "./TabsComponent";
import Refresh from "./RefreshComponent";
import SettingsMenu from "./SettingsMenuComponent";
import Logout from "./LogoutComponent";

export default {
    components: {
        Logo,
        Search,
        Tabs,
        Refresh,
        SettingsMenu,
        Logout,
    },
};
</script>
